// extracted by mini-css-extract-plugin
export default {"addInvoice":"AddInvoice_addInvoice__hMsJy"};